/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Kind_Plan_Day_AddInputs */

const en_us2_offline_kind_plan_day_add = /** @type {(inputs: Offline_Kind_Plan_Day_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workout added to the plan`)
};

const pt_br2_offline_kind_plan_day_add = /** @type {(inputs: Offline_Kind_Plan_Day_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treino criado no plano`)
};

const es_419_offline_kind_plan_day_add = /** @type {(inputs: Offline_Kind_Plan_Day_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrenamiento agregado al plan`)
};

const pt_pt2_offline_kind_plan_day_add = /** @type {(inputs: Offline_Kind_Plan_Day_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treino criado no plano`)
};

const fr_fr2_offline_kind_plan_day_add = /** @type {(inputs: Offline_Kind_Plan_Day_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Séance ajoutée au programme`)
};

const de_de2_offline_kind_plan_day_add = /** @type {(inputs: Offline_Kind_Plan_Day_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Training zum Plan hinzugefügt`)
};

const it_it2_offline_kind_plan_day_add = /** @type {(inputs: Offline_Kind_Plan_Day_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allenamento aggiunto alla scheda`)
};

/**
* | output |
* | --- |
* | "Workout added to the plan" |
*
* @param {Offline_Kind_Plan_Day_AddInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const offline_kind_plan_day_add = /** @type {((inputs?: Offline_Kind_Plan_Day_AddInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Kind_Plan_Day_AddInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_offline_kind_plan_day_add(inputs)
	if (locale === "es-419") return es_419_offline_kind_plan_day_add(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_kind_plan_day_add(inputs)
	if (locale === "fr-FR") return fr_fr2_offline_kind_plan_day_add(inputs)
	if (locale === "de-DE") return de_de2_offline_kind_plan_day_add(inputs)
	if (locale === "it-IT") return it_it2_offline_kind_plan_day_add(inputs)
	return en_us2_offline_kind_plan_day_add(inputs)
});
export { offline_kind_plan_day_add as "offline.kind_plan_day_add" }